module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1mkM4F/images/cover.jpg?1685204507417",
      "alt": "This image is the cover for the book I Bring the Voices of My People"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("I Bring the Voices of My People\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('i', [_vm._v("Disrupting the racist and sexist biases in conversations on reconciliation")])]), _c('p', [_vm._v("Chanequa Walker-Barnes offers a compelling argument that the Christian racial reconciliation movement is incapable of responding to modern-day racism. She demonstrates how reconciliation’s roots in the evangelical, male-centered Promise Keepers’ movement has resulted in a patriarchal and largely symbolic effort, focused upon improving relationships between men from various racial-ethnic groups.")]), _c('p', [_vm._v("Walker-Barnes argues that highlighting the voices of women of color is critical to developing any genuine efforts toward reconciliation. Drawing upon intersectionality theory and critical race studies, she demonstrates how living at the intersection of racism and sexism exposes women of color to unique experiences of gendered racism that are not about relationships, but rather are about systems of power and inequity.")]), _c('p', [_vm._v("Refuting the idea that race and racism are “one-size-fits-all,” "), _c('i', [_vm._v("I Bring the Voices of My People ")]), _vm._v("highlights the particular work that White Americans must do to repent of racism and to work toward racial justice and offers a constructive view of reconciliation that prioritizes eliminating racial injustice and healing the damage that it has done to African Americans and other people of color.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Chanequa Walker-Barnes\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0